import axiosService from '@/api/axios';
import { AxiosResponse } from 'axios';

export const getDataList = async (dataUrl: string): Promise<AxiosResponse> => {
  return await axiosService.get(dataUrl);
};


